import type { FC } from 'react';
import { useLayoutEffect } from 'react';
import { StyledMain, StyledWrapper } from './layout.styles';
import { Footer } from '../Footer/footer.component';
import { Outlet, useLocation } from 'react-router';
import { Header } from '../Header/header.component';
import { Cookies } from '../Cookies/cookies.component';

export const Layout: FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <StyledWrapper>
      <Header />
      <StyledMain
        key={pathname}
        initial="initial"
        animate="in"
        variants={{
          in: { opacity: 1 },
          initial: { opacity: 0 },
          out: { opacity: 0 },
        }}
        transition={{ duration: 0.4, ease: 'linear', type: 'tween' }}
      >
        <Outlet />
      </StyledMain>
      <Footer />
      <Cookies />
    </StyledWrapper>
  );
};
